import { FormattedMessage } from 'react-intl';

/**
 * @description Renders a localised dash (`"-"`) as a placeholder for null or missing values in table cells and detail rows.
 * @returns {JSX.Element} A formatted dash character.
 */
export default function RowDash() {
  return (
    <FormattedMessage id='+PaPHS' defaultMessage='-' description='null value' />
  );
}
